import main from '@statistics/pages/main.vue';
export default [
  {
    path: 'statistics',
    component: main,
    redirect: 'statistics',
    children: [
      {
        path: '',
        name: 'statistics',
        meta: { title: '交易数据统计', auth: true },
        component: () => import('@statistics/pages/index.vue'),
      },
      {
        path: 'interface',
        name: 'statistics/interface',
        meta: { title: '交易数据统计', auth: true },
        component: () => import('@statistics/pages/interface.vue'),
      },
    ],
  },
];
